import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CoverageRange, ADPResourceService as ResourceService } from 'digital-core';

@Injectable()
export class CurrencyService {

  locale: string;
  currency: string;

  constructor(private resourceService: ResourceService) {
    this.setLocalizationSettings();
  }

  setLocalizationSettings() {
    let localizationSetting = this.resourceService.getLocalizationSettings();

    this.locale = localizationSetting.ClientLocalLanguage;
    this.currency = localizationSetting.ClientLocalCurrency;
  }

  formatCurrency(formGroup, propertyName, _minimumFractionDigits?, _maximumFractionDigits?, replaceInvalidByZero?) {
    let minDecimalPlaces = _minimumFractionDigits !== undefined ? _minimumFractionDigits : 2;
    let maxDecimalPlaces = _maximumFractionDigits !== undefined ? _maximumFractionDigits : 2;
    let price = formGroup.get(propertyName).value;



    if (price) {
      price = this.reverseFormatNumber(price);
      if (isNaN(price)) {
        if (replaceInvalidByZero) {
          formGroup.controls[propertyName].setValue("0");
          return;
        } else {
          formGroup.controls[propertyName].setErrors({ validateDate: false });
          return;
        }

      }

      // Test
      if (minDecimalPlaces === 0 && maxDecimalPlaces === 0) {
        price = Math.floor(price);
      }

      let currency = new Intl.NumberFormat(this.locale, {
        style: "currency",
        currency: this.currency,
        maximumFractionDigits: maxDecimalPlaces,
        minimumFractionDigits: minDecimalPlaces
      }).format(price);
      if (currency !== "NaN") {
        formGroup.controls[propertyName].setValue(currency);
      } else {
        formGroup.controls[propertyName].setErrors({ validateDate: false });
      }
    }
  }

  formatNumberCurrency(value, minimumFractionDigits?: number) {
    let minDecimalPlaces = minimumFractionDigits === undefined || minimumFractionDigits === null ? 2 : minimumFractionDigits;
    if (value >= 0) {
      let currency = new Intl.NumberFormat(this.locale, {
        style: "currency",
        currency: this.currency,
        minimumFractionDigits: minDecimalPlaces
      }).format(value);
      if (currency !== "NaN") {
        return currency
      } else {
        return 0;
      }
    }
  }

  formatNumberCurrencyNoSymbol(value, minimumFractionDigits?) {
    let minDecimalPlaces = minimumFractionDigits !== undefined ? minimumFractionDigits : 2;
    if (value >= 0) {
      let currency = new Intl.NumberFormat(this.locale, { minimumFractionDigits: minDecimalPlaces }).format(value);
      if (currency !== "NaN") {
        return currency
      } else {
        return 0;
      }
    }
  }

  public reverseFormatNumber(val) {
    let locale = this.locale;
    val = String(val).replace(/[^0-9.,]+/g, "");
    let group = new Intl.NumberFormat(locale).format(11111).replace(/1/g, "")
    // Adding below condition, If group is a blank string
    if(group==''){
      group = '.';
    }
    let decimal = new Intl.NumberFormat(locale).format(1.1).replace(/1/g, "");
    let reversedVal = val.replace(new RegExp("\\" + group, "g"), "");
    reversedVal = reversedVal.replace(new RegExp("\\" + decimal, "g"), ".");

    if (isNaN(parseInt(val.charAt(0), 10))) {
      reversedVal = reversedVal.slice(1); // to remove currency character , double check this logic
    }

    return Number.isNaN(reversedVal) ? 0 : Number.parseFloat(reversedVal);
  }

  getPriceRange() {
    // Rounding coverage range values to avoid validator triggering false positives
    let _min = Number(
      this.resourceService.getPortalSetting("DevicePrice_MinValue").Value
    );
    let _max = Number(
      this.resourceService.getPortalSetting("DevicePrice_MaxValue").Value
    );
    let _coverageRange = new CoverageRange(_min, _max);
    return _coverageRange;
  }

  formatCurrencyForInput(form: FormGroup, formControl: string) {
    let price = form.get(formControl).value;
    if (!price) {
      return { required: { valid: false } };
    }
    price = this.reverseFormatNumber(price);
    if (isNaN(price)) {
      form.controls[formControl].setErrors({
        validateDate: false
      });
      return;
    }
    const currency = new Intl.NumberFormat(this.locale, {
      style: "currency",
      currency: this.currency
    }).format(price);
    // Checks if range validator has already been set for invalid Price range (outside Min and Max value)
    const validPriceRange = form.controls[formControl].status;
    if (currency !== "NaN" && validPriceRange === "VALID") {
      form.controls[formControl].setValue(currency);
    } else {
      form.controls[formControl].setErrors({
        validateDate: false
      });
    }
  }

}
